import { useMe, useMeData } from "../hooks/useMe";
import React from "react";
import { H6, Spinner } from "@blueprintjs/core";
import "moment-timezone";
import moment from "moment";
import "styled-components/macro";
import { useModedEndpoint } from "../use-app-mode-endpoint";
import { useAppMode, useItinMode } from "../store/model-misc";
import { useEndpoint } from "../helpers/use-endpoint";

export function DataRefreshStats() {
  const appMode = useAppMode();
  const itinMode = useItinMode();

  return !appMode ? null : (
    <div
      css={`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      `}
    >
      <TripsRefreshedAt appMode={appMode} />
      <OppsRefreshedAt appMode={appMode} itinMode={itinMode} />
    </div>
  );
}

export function TripsRefreshedAt({ appMode }) {
  const { loading, data } = useEndpoint("/trips_data_freshness");
  return loading ? (
    <Spinner size={Spinner.SIZE_SMALL} />
  ) : (
    <Statline name="Trips Refreshed" dts={data} marginBottom={"8px"} />
  );
}

export function OppsRefreshedAt({ appMode, itinMode }) {
  const { loading, data } = useModedEndpoint(
    "opps_refreshed_at",
    appMode,
    itinMode
  );

  return loading ? (
    <Spinner size={Spinner.SIZE_SMALL} />
  ) : (
    <Statline name="Opportunities Refreshed" dts={data} />
  );
}

function Statline({ name, dts, marginBottom = "0" }) {
  const content = useStatlineContent(dts, name);
  return (
    <H6
      css={`
        font-size: 10px;
        font-weight: normal;
        margin: 0 10px ${marginBottom} 0 !important;
      `}
    >
      {content}
    </H6>
  );
}

function useStatlineContent(dts, name) {
  const timezone = useUserTimezone();
  if (dts && timezone) {
    return `${name}: ${formatTimestamp(dts, timezone)}`;
  } else {
    return "";
  }
}
export function useUserTimezone() {
  const { loading } = useMe();
  const meData = useMeData();
  if (loading || !meData || !meData.timezone) {
    return null;
  } else {
    return meData.timezone;
  }
}

function formatTimestamp(dts, timezone) {
  return moment(dts).tz(timezone).format("MM/DD/YY [at] hh:mm A (z)");
}
